export class DocumentMaster{
    public documentId:number;
    public documentName:string;
    public filePath:string;
    public actualPath: string;
    public fileKey: string;
    public documentType: string;
    public fileType: string;
    public entityName: string;
    public documentNameThumbnail: string;
    public s3KeyThumbnail: string;
    public filePathThumbnail: string;
    public link: string;
    public linkId: string;
    public title: string;
    public description: string;
    public isDelete: string;
    public documentSelectedPath: string;
    public folderName: string;
    public videoResumeTime: number;
    public studentLectureContentMasterId: number;
    public duration: number;
    public url:any;
    

}